import React from 'react'
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-rotate.css';
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgAutoplay from "lightgallery/plugins/autoplay";
import lgVideo from "lightgallery/plugins/video";
import lgShare from "lightgallery/plugins/share";
import lgRotate from "lightgallery/plugins/rotate";
const Slider_certiticate = {
    dots: true,
    nav: true,
    infinite: true,
    speed: 500,
    lazyLoad: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 4000,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                initialSlide: 0
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};
const Home_certificate = () => {
    const JavascriptVoid = (event) => {
        event.preventDefault();
    };
    const certificateobj = [
        {
            id: 1,
            img: "assets/certificate-img/certifications-logo/cmmi3.webp",
            certification_name:"CMMi3"
        },
        {
            id: 2,
            img: "assets/certificate-img/certifications-logo/itca.webp",
            certification_name:"ITCA"
        },
        {
            id: 3,
            img: "assets/certificate-img/certifications-logo/alobha_msme-certificate.webp",
            certification_name:"MSME"
        },
        {
            id: 4,
            img: "assets/certificate-img/certifications-logo/9001.webp",
            certification_name:"Quality Management System"
        },
        {
            id: 5,
            img: "assets/certificate-img/certifications-logo/14001.webp",
            certification_name:"Information Security System"
        },
        {
            id: 6,
            img: "assets/certificate-img/certifications-logo/27001.webp",
            certification_name:"ISO"
        },
        {
            id: 7,
            img: "assets/certificate-img/certifications-logo/udyog_adhar.webp",
            certification_name:"Udyog Adhar"
        },
        {
            id: 8,
            img: "assets/certificate-img/certifications-logo/uk.webp",
            certification_name:"UK Global"
        },
    ]
    const certiImg = {
        height: "200px !important",
        // border: "1px solid #ccc",
    };
    const certifctSubDv = {
        marginTop: "0",
        marginBottom: "0",
        marginRight: "5px",
        marginLeft: "5px",
    };
    return (
        <>
            <section className="our-certification ptb-80 partners pb-4">
                <div className="container">
                    <div className="section-title">
                        <h2 className='fontkumbh'>Our Certifications & Accreditation</h2>
                        <div className="bar"></div>
                    </div>
                    <div className="slider " >
                        <Slider {...Slider_certiticate}>
                            {certificateobj.map((grpcard) => {
                                return <div className="certifct-head py-4" key={grpcard.id}>
                                    <div className="certifct-sub-dv" style={certifctSubDv}>
                                        {/* <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                                <a href={grpcard.img} data-lightbox="image-1" >
                                                    <img src={grpcard.img} className="img-fluid mx-auto certi-img" alt="Project  Screens" style={certiImg} />
                                                </a>
                                            </LightGallery> */}
                                        <div class="card" className='mx-1 card-slider-shadow'>
                                        <img src={grpcard.img} className="img-fluid mx-auto certi-img" alt="Project  Screens" style={certiImg} />
                                            <div class="card-body">
                                                <h5 class="card-title fontkumbh" style={{textAlign:"center"}}>{grpcard.certification_name}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </Slider>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Home_certificate